import React, {useState} from 'react';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const NetworkEngineerFilter = ({
                                   applyFilter,
                                   roleId
                               }) => {
    const filterInputs = {
        site_name: '',
        site_no: ''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
            }}
        >
            <ConstantInput
                label={localization.siteName}
                value={filterFieldsData.site_name}
                regex={Regex.text.test(filterFieldsData.site_name)}
                type="text"
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, site_name: val})
                }
            />
            <ConstantInput
                label={localization.siteNumber}
                value={filterFieldsData.site_no}
                regex={Regex.text.test(filterFieldsData.site_no)}
                type="text"
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, site_no: val})
                }
            />

            <br/>
            <br/>
            <br/>
            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src="../images/arrow-right.png" alt=""/>
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        applyFilter(filterInputs);
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default NetworkEngineerFilter;
